// REMEMBER TO UPDATE environment.ts

export const environment = {
  production: true,
  api_url: '/api/v1',
  wifi_disabled: false,
  // version: code_version,
  google_client_id: '722825241230-eephdv7379upl0psuokdud57tl63udrc.apps.googleusercontent.com', // updated: lcp-website-client-1
  
  paypal_base: 'http://sandbox.paypal.com',

  contentful: {
    spaceId: 'ertyhukhlvrl', // lcp
    accessToken: '-8jByx7qnH9lWSMTeyew26HGK7YE7s7pQu8t8cdTxHk', // lcp
    environment: 'master', // replace with your environment ID if needed - master is the default production environment in Contentful
  },
}
